<!-- P12S0 Component - Section 871(m) Tax Liability of QDD -->
<div class="f1065-k2-container">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>
    
    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    <!-- FORM CONTENT -->
    @if (!showLoader) {
<div>
    <!-- Section Header -->
    <p class="h5 section-header"><b>{{ sectionHeader }}</b></p>

    <div class="table-responsive table-container">
      <table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            <th class="hd-sno" style="text-align: center;">Line</th>
            <th style="text-align: center;">Summary of QDD Tax Liability</th>
            @for (cols of colHeaderData | orderBy:'COL_PRIORITY'; track $index) {
<th
                style="width:122px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }} @if (cols.IS_MANDATORY === 'Y') {
<span>*</span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of groupedFormLines | filterBy:'IS_DISPLAY':'Y' | orderBy:['LINE_ORDER', 'SNO']; track trackByRow(rowIdx, x); let rowIdx = $index) {
<tr>
            
            <!-- Line Number -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              <!-- Add button: only for line 5, SNO == 0 -->
              @if (x.LINE_NO === '5' && x.SNO === 0) {
<i
                 class="fa fa-plus-circle color-green"
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              <!-- Delete button: only for SNO > 0 -->
              @if (x.SNO > 0) {
<i
                 class="fa fa-minus-circle color-red"
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.LINE_NO) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td><p>{{ x.LINE_DESC }}</p></td>

            <!-- Data Columns -->
            @for (amts of x.items | orderBy:'COL_ORDER'; track trackByCol(colIdx, amts); let colIdx = $index) {
<td
                style="height: 30px; width:122px; text-align: right;">
              
              <!-- Column (b) - decimal, other columns - integers -->
              @if (!shouldHideInput(x, colIdx) && amts.COL_DESC_INFO === 'b') {
<input
                     type="text" class="form-control min-ele-wid"
                     [ngClass]="{'custom-error': amts.IS_ERROR === 'Y', 'custom-textbox': amts.IS_ENABLED === 'Y'}"
                     [(ngModel)]="amts.CELL_VALUE" [disabled]="amts.IS_ENABLED === 'N'" [readonly]="isLastColumn(x.items, colIdx)"
                     onlyDigitsDecimalWithLength [decimalDigits]="4"
                     (ngModelChange)="calcTotalsCol(x, x.items)" style="text-align: right;">
}
              @if (!shouldHideInput(x, colIdx) && amts.COL_DESC_INFO !== 'b') {
<input
                     type="text" class="form-control min-ele-wid"
                     [ngClass]="{'custom-error': amts.IS_ERROR === 'Y', 'custom-textbox': amts.IS_ENABLED === 'Y'}"
                     [(ngModel)]="amts.CELL_VALUE" [disabled]="amts.IS_ENABLED === 'N'" [readonly]="isLastColumn(x.items, colIdx)"
                     onlyIntegersWithLength
                     (ngModelChange)="calcTotalsCol(x, x.items)" style="text-align: right;">
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- Action Buttons -->
    @if (isAdmin) {
<div class="k2-buttons-container">
      <button class="save-button" type="button" (click)="save()" [disabled]="isSaveClicked">Save</button>
      <button class="reset-button" type="button" (click)="reset()" [disabled]="!isAdmin">Reset</button>
    </div>
}
    </div>
} <!-- closes content -->
  </div>
} <!-- closes !loadingData -->
</div> <!-- closes f1065-k2-container -->

<!-- Confirmation Modal -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onSaveConfirm()"
    (cancelled)="onSaveCancel()"
    (closed)="onSaveCancel()">
  </gtw-confirmation-modal>
</div>
}
